import { Box } from '@material-ui/core';
import axios from 'axios';
import { saveAs } from 'file-saver';
import 'font-awesome/css/font-awesome.css';
import React, { Component } from 'react';
import BlockUi from 'react-block-ui';
import { Col, DropdownButton, MenuItem, Row } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import 'react-datepicker/dist/react-datepicker.css';
import { connect } from 'react-redux';
import 'react-select/dist/react-select.css';
import BeatLoader from 'react-spinners/BeatLoader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import {
  fetchDocumentsByPodcastDbIds,
  fetchDocumentsWithFlags,
  fetchPodcastsWithFlags,
  fetchUserGroups,
  setPlaybackFlags,
  setPlayingDocumentId,
  updateDocument,
  updateUserFields
} from '../redux/actions/app-actions';
import {
  fetchSearchFlags,
  fetchTagsByUser,
  resetFlags,
  startFetchingFlags
} from '../redux/actions/flag-actions';
import { setExpand } from '../redux/actions/pdf-actions';
import {
  setDisableSkipAheadButton,
  setDisableSkipBackButton,
  setIsSelectedFlags,
  setFlagAdded,
  setOnPlaylist,
  setPlayResource,
  setPlayerDocument,
  setPlayerFlag,
  setShowSkipButton
} from '../redux/actions/player-actions';
import { default as config } from '../constants/constants';
import { firebase } from '../firebase';
import { requestForToken, subscribeToMessages } from '../firebase/firebase';
import { handleDeleteFlags } from '../utils/flag';
import logo from '../images/inflo_logo.png';
import withAuthorization from '../session/with_authorization';
import { displayNotification } from '../utils/utils';
import Navigation from '../components/header/Navigation';
import ShareFlags from '../components/share-flags/ShareFlags';
import SearchSkeletonLoader from '../components/ui/skeleton/SearchSkeletonLoader';
import ConfirmationDeleteModal from '../features/flags/components/ConfirmationDeleteModal';
import FlagRow from '../features/flags/components/FlagRow';
import FlagRowHeader from '../features/flags/components/FlagRowHeader';
import FlagsActions from '../features/flags/components/FlagsActions';
import FlagsFilters from '../features/flags/components/flag-filters/FlagsFilters';
import FlagsSelectedActions from '../features/flags/components/FlagsSelectedActions';
import '../features/flags/styles/flags.css';
import { initializePollyProcess } from '../features/flags/components/pollyProcess';
import {
  isUserStatusFree,
  isUserStatusSubscribed
} from '../utils/CheckUserStatus';
import {
  isSubscriptionTypeElite,
  isSubscriptionTypePro
} from '../utils/CheckSubscriptionType';

toast.configure();

// Notification status for transcription ready
const FLAG_TRANSCRIPTION_READY = 'FLAG_TRANSCRIPTION_READY';

class FlagsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valuesTags: [],
      valuesPodcasts: [],
      valuesDocuments: [],
      from: null,
      to: null,
      blocking: false,
      /**
       * Is needed for media palyer data.
       * The documentsWithFlags variable stored in Redux is updated when new Podcasts are selected
       */
      documents: [],
      flashflag: false,
      hiddenCheckBox: true,
      collapseForm: false,
      filterFlags: [
        { name: 'My Flags', id: 1, selected: true },
        { name: 'Shared Flags', id: 2, selected: false }
      ],
      selectedItems: [],
      hiddenSelectionCheckbox: true,
      error: { hasError: false, errorMessage: '' },
      isExpandedView: true,
      shareModalOpen: false,
      flagsToShare: [],
      groupedFlags: [],
      transformedData: [],
      userFilterSelectedItems: [-1],
      openConfirmationDeleteModal: false,
      isDocumentsFetching: false
    };
    this.tableOptions = {
      onSizePerPageList: this.sizePerPageListChange.bind(this),
      sizePerPage: parseInt(localStorage.getItem('flag-page-table-size')) || 10
    };
    this.expandComponent = this.expandComponent.bind(this);
  }

  sizePerPageListChange(sizePerPage) {
    localStorage.setItem('flag-page-table-size', sizePerPage);
  }

  initFetchSearchFlags = async (token, criteria) => {
    await this.props.dispatch(startFetchingFlags());
    await this.props.dispatch(fetchSearchFlags(token, criteria, true));
  };

  async componentDidMount() {
    this.setState({ isDocumentsFetching: true });

    try {
      const token = await firebase.auth.currentUser.getIdToken();

      if (token) {
        await this.props.dispatch(fetchTagsByUser(token));
        await this.props.dispatch(fetchPodcastsWithFlags(token));
        await this.props.dispatch(fetchDocumentsWithFlags(token));
        this.setState({
          documents: this.props.documents,
          blocking: false
        });
        await this.props.dispatch(setExpand(false));
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isDocumentsFetching: false });
    }
    
    this.props.dispatch(setOnPlaylist(false));
    this.registerForTranscriptionNotifications();
  }

  registerForTranscriptionNotifications = async () => {
    try {
      const user = firebase.auth.currentUser;

      if (!user || typeof Notification === 'undefined') {
        return;
      }

      const browserPermission = await Notification.requestPermission();

      if (browserPermission !== 'granted') {
        return;
      }

      const fcmToken = await requestForToken();

      if (!fcmToken) {
        return;
      }

      const authToken = await user.getIdToken();
      await this.props.dispatch(
        updateUserFields(authToken, { notification_web_token: fcmToken })
      );

      this.unsubscribeFromMessages = subscribeToMessages((payload) => {
        if (payload?.data?.status === FLAG_TRANSCRIPTION_READY) {
          this.refresh();
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  componentWillUnmount() {
    // Unsubscribe from Firebase Cloud Messaging
    if (this.unsubscribeFromMessages) {
      this.unsubscribeFromMessages();
      this.unsubscribeFromMessages = null;
    }
  }

  componentDidUpdate(prevProps) {
    const {
      userFilterSelectedItems,
      filterFlags,
      error: { hasError, errorMessage }
    } = this.state;
    const { flagsSearch, flagAdded } = this.props;

    this.handleSharedFlagsUsers(flagsSearch);

    if (prevProps.flagsSearch !== flagsSearch) {
      if (
        userFilterSelectedItems.length === 1 &&
        userFilterSelectedItems[0] === -1
      ) {
        this.renderGroupedFlags(flagsSearch, filterFlags, []);
      } else {
        this.renderGroupedFlags(
          flagsSearch,
          filterFlags,
          userFilterSelectedItems
        );
      }
    }

    if (flagAdded) {
      let values = this.getSearchCriteria();
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.initFetchSearchFlags(token, values);
        this.props.dispatch(setFlagAdded(false));
      });
    }

    if (hasError) {
      toast.error(errorMessage, {
        position: 'top-right',
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        onClick: () => {
          this.setState({ error: { hasError: false, errorMessage: '' } });
        },
        pauseOnHover: true,
        draggable: true
      });
    }
  }

  handleSelectOnFocus = () => {
    this.setState({ hiddenCheckBox: false });
  };

  handleSelectChangeTags = (valuesTags) => {
    this.setState({ valuesTags });
  };

  handleSelectChangePodcasts = async (valuesPodcasts) => {
    this.setState({ valuesPodcasts, isDocumentsFetching: true });

    try {
      const token = await firebase.auth.currentUser.getIdToken();

      if (token) {
        if (valuesPodcasts.length > 0) {
          this.setState({ valuesDocuments: [] });
          await this.props.dispatch(
            fetchDocumentsByPodcastDbIds(token, valuesPodcasts)
          );
        } else {
          this.setState({ valuesDocuments: [] });
          await this.props.dispatch(fetchDocumentsWithFlags(token));
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isDocumentsFetching: false });
    }
  };

  handleSelectChangeDocuments = (valuesDocuments) => {
    this.setState({ valuesDocuments });
  };

  handleChangeFrom = (from) => {
    this.setState({ from });
  };

  handleChangeTo = (to) => {
    this.setState({ to });
  };

  getSearchCriteria = () => {
    let values = {};

    let vtag = this.state.valuesTags;
    let vpod = this.state.valuesPodcasts;
    let vepis = this.state.valuesDocuments;
    let from = this.state.from;
    let to = this.state.to;
    let flashflag = this.state.flashflag;

    // Source https://maggiepint.com/2016/05/14/moment-js-shows-the-wrong-date/
    values.fromDate = from ? from.utc('YYYY-MM-DD').format() : from;
    values.toDate = to
      ? to
          .endOf('day')
          .utc('YYYY-MM-DD')
          .format()
      : to;

    const valuesTg = [];

    if (vtag && vtag.length > 0) {
      vtag = vtag.split(',');
      if (vtag.length > 0) {
        vtag.forEach((p) => {
          valuesTg.push(p);
        });
      }
    } else {
      vtag = [];
    }

    const valuesPod = [];

    if (vpod && vpod.length > 0) {
      vpod = vpod.split(',');
      if (vpod.length > 0) {
        vpod.forEach((p) => {
          valuesPod.push(parseInt(p, 10));
        });
      }
    } else {
      vpod = [];
    }

    const valuesEpis = [];

    if (vepis && vepis.length > 0) {
      vepis = vepis.split(',');
      if (vepis.length > 0) {
        vepis.forEach((p) => {
          valuesEpis.push(parseInt(p, 10));
        });
      }
    } else {
      vepis = [];
    }

    values.tagsName = valuesTg;
    values.podcastIds = valuesPod;
    values.documentIds = valuesEpis;
    values.flashflag = flashflag;

    return values;
  };

  /**
   * handle form/filter submit
   */
  handleSubmit = () => {
    this.setState({ blocking: true });
    let values = this.getSearchCriteria();

    firebase.auth.currentUser.getIdToken().then((token) => {
      this.initFetchSearchFlags(token, values);
      this.setState({ documents: this.props.documents, blocking: false });
    });

    if (values.flashflag != null && values.flashflag) {
      this.setState({ hiddenCheckBox: false });
    } else {
      this.setState({ hiddenCheckBox: true });
    }
  };

  /**
   * reset form/filter fields
   */
  resetForm = () => {
    this.setState({ from: null });
    this.setState({ to: null });
    this.setState({ valuesTags: [] });
    this.setState({ valuesPodcasts: [] });
    this.setState({ valuesDocuments: [] });
    this.setState({ flashflag: false });

    this.props.dispatch(resetFlags());
  };

  tagsList = () => {
    let array = [];
    let temp = {};
    let isPresent = false;
    let tags = this.props.tags;
    if (tags && tags.length > 0) {
      tags.forEach((p) => {
        if (p.tag !== 'DOWNTAG' && p.tag !== 'UPTAG') {
          if (p.tag === 'FLASH' && !isPresent) {
            temp = {};
            isPresent = true;
            temp.value = `${p.tag}`;
            temp.label = p.tag;
            array.push(temp);
          } else if (p.tag !== 'FLASH') {
            temp = {};
            temp.value = `${p.tag}`;
            temp.label = p.tag;
            array.push(temp);
          }
        }
      });
    }
    return array;
  };

  podcastsList = () => {
    let array = [];
    let temp = {};

    let podcasts = this.props.podcastsWithFlags || [];

    if (podcasts && podcasts.length > 0) {
      podcasts.forEach((p) => {
        temp = {};
        temp.value = `${p.id}`;
        temp.label = p.name;
        array.push(temp);
      });
    }

    return array;
  };

  documentsList = () => {
    let array = [];
    let temp = {};

    let documents = this.props.documents;

    if (documents && documents.length > 0) {
      documents.forEach((p) => {
        temp = {};
        temp.value = `${p.id}`;
        temp.label = p.episodeName || '';
        array.push(temp);
      });
    }

    return array;
  };

  isExpandableRow() {
    return true;
  }

  expandComponent(row) {
    const cellEditProp = {
      mode: 'click',
      blurToSave: true,
      afterSaveCell: this.onAfterSaveCell
    };

    let data = [];
    data = [
      {
        text: row.text,
        dictation: row.dictation,
        id: row.flagId,
        processing: row.processing
      }
    ];

    const tdStyle = () => {
      return {
        whiteSpace: 'normal',
        backgroundColor: '#28313b',
        color: '#EDEEEF'
      };
    };

    return (
      <div className="noBorderSubTableTag">
        <BootstrapTable cellEdit={cellEditProp} bordered={false} data={data}>
          <TableHeaderColumn dataField="processing" hidden>
            Processing
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="text"
            editable={false}
            dataFormat={this.formatTranscript}
            tdStyle={tdStyle}
            isKey={true}
          >
            Transcript Text
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="dictation"
            dataFormat={this.formatDictation}
            tdStyle={{ ...tdStyle(), cursor: 'pointer' }}
          >
            Dictation
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }

  formatTranscript = (cell, row) => {
    if (cell) return cell;
    if (row.processing) {
      return (
        <>
          <span>Transcription in progress</span>
          <div style={{ display: 'flex' }}>
            <BeatLoader size={10} color={'#E31690'} />
            <div style={{ marginLeft: '35%' }} onClick={this.refresh}>
              <i
                className="fa fa-refresh"
                aria-hidden="true"
                style={{ fontSize: '13pt', color: '#E31690' }}
                title="Refresh"
              ></i>
            </div>
          </div>
        </>
      );
    } else {
      return null;
    }
  };

  formatDictation = (cell, row) => (
    <div className="dictation">
      {cell != null && cell != '' ? cell : 'None'}
    </div>
  );

  refresh = () => {
    firebase.auth.currentUser.getIdToken().then((token) => {
      let values = this.getSearchCriteria();
      // this.props.dispatch(fetchSearchFlags(token, values))
      this.initFetchSearchFlags(token, values);
    });
  };

  formatDate = (cell) => {
    // convert server date string format MM-dd-yyyy hh:mm:ss to a string that is compliant with ECHAScript date specification format YYYY-MM-DDTHH:mm:ss.sssZ
    // https://tc39.es/ecma262/#sec-date-time-string-format
    const dateString = `${cell.substring(6, 10)}-${cell.substring(
      0,
      2
    )}-${cell.substring(3, 5)}T${cell.substring(11)}Z`;
    const utcDate = new Date(dateString);
    // convert UTC date to local date in string format MM/dd/yyyy, hh:mm:ss
    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour12: true
    };
    const date = utcDate.toLocaleDateString('en-US', options);
    const formatedDate = date.replace(/\//g, '-').replace(/,/g, '');
    return (
      <div>
        <strong>{formatedDate}</strong>
      </div>
    );
  };

  export = (exportType, sortBy) => {
    if (this.props.flagsSearch && this.props.flagsSearch.length === 0) {
      swal({
        imageUrl: logo,
        title: '<div class="titleModal">Notice</div>',
        html: '<p class="contentModal">There aren\'t flags to export.</p>',
        showConfirmButton: false,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false
      });
      return;
    }
    this.setState({ blocking: true });
    let values = this.getSearchCriteria();
    let $this = this;

    //const axiosInstance = getAxiosInstance();
    // immediately affects this instance
    axios.defaults.responseType = 'blob';
    axios.defaults.timeout = 60000;

    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        const options = {
          method: 'POST',
          headers: { 'X-Firebase-Auth': token },
          url: `${config.serverURL}/notes/export?exportType=${exportType}&sortBy=${sortBy}`,
          data: this.props.flagsSearch
        };

        this.setState({ blocking: true });
        axios(options)
          .then(function(response) {
            $this.setState({ blocking: false });
            var mimeType =
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            if (exportType === 'pdf') {
              mimeType = 'application/pdf';
            } else if (exportType === 'odt') {
              mimeType = 'application/vnd.oasis.opendocument.text';
            }

            var blob = new Blob([response.data], { type: mimeType });
            saveAs(blob, `Flags.${exportType}`);

            // reset to defaults
            axios.defaults.responseType = 'text';
            axios.defaults.timeout = 30000;
          })
          .catch(function(error) {
            $this.setState({ blocking: false });

            // reset to defaults
            axios.defaults.responseType = 'text';
            axios.defaults.timeout = 30000;
          });
      });
    }
  };

  createCustomExportCSVButton = () => {
    let titleButton = (
      <i className="fa">
        &#xf019; <span id="font-export">Export</span>
      </i>
    );
    return (
      <DropdownButton
        id="export-menu"
        title={titleButton}
        className="btn-tags"
        onClick={(e) => {
          e.preventDefault();
          return false;
        }}
      >
        <MenuItem
          pdown="true"
          eventKey="1"
          onClick={(e) => {
            e.preventDefault();
            this.export('pdf', 'podcast');
          }}
        >
          <i className="fa">&#xf1c1;</i> Sort by Podcast
        </MenuItem>
        <MenuItem
          pdown="true"
          eventKey="2"
          onClick={(e) => {
            e.preventDefault();
            this.export('pdf', 'tag');
          }}
        >
          <i className="fa">&#xf1c1;</i> Sort by Tag
        </MenuItem>
      </DropdownButton>
    );
  };

  updateDocument = (token, values) => {
    this.props.dispatch(updateDocument(token, values));
  };

  onChangeHandler = (e) => {
    if (e.target.checked) {
      this.setState({ flashflag: true });
    } else {
      this.setState({ flashflag: false });
    }
  };

  handlerFormCollapse = () => {
    //  this.setState({ collapseForm: !this.state.collapseForm });
    this.setState({ isExpandedView: true });
  };

  // handle filters (My Flags or Shared Flags)
  handleFilterFlags = (index, flagId) => {
    // Create a copy of the filterFlags array
    const updatedFilterFlags = [...this.state.filterFlags];

    // Check the current state of the clicked button
    const currentSelection = updatedFilterFlags[index].selected;

    // If the clicked button is already selected and only one button is selected,
    // do not allow the deselection of the button
    if (
      currentSelection &&
      updatedFilterFlags.filter((flag) => flag.selected).length === 1
    ) {
      if (flagId === 1) {
        updatedFilterFlags[flagId].selected = !updatedFilterFlags[flagId]
          .selected;
        updatedFilterFlags[0].selected = !updatedFilterFlags[0].selected;
      } else {
        updatedFilterFlags[flagId - 1].selected = !updatedFilterFlags[
          flagId - 1
        ].selected;
        updatedFilterFlags[0].selected = !updatedFilterFlags[0].selected;
        this.setState({ userFilterSelectedItems: [-1] });
      }
      this.setState({ filterFlags: updatedFilterFlags });
      if (
        this.state.userFilterSelectedItems.length === 1 &&
        this.state.userFilterSelectedItems[0] === -1
      ) {
        this.renderGroupedFlags(this.props.flagsSearch, updatedFilterFlags, []);
      } else {
        this.renderGroupedFlags(
          this.props.flagsSearch,
          updatedFilterFlags,
          this.state.userFilterSelectedItems
        );
      }

      return;
    }

    if (currentSelection && flagId === 2) {
      this.setState({ userFilterSelectedItems: [-1] });
    }

    // Toggle the selected property of the clicked button
    updatedFilterFlags[index].selected = !currentSelection;

    // Update the state with the modified filterFlags array
    this.setState({ filterFlags: updatedFilterFlags });
    if (
      this.state.userFilterSelectedItems.length === 1 &&
      this.state.userFilterSelectedItems[0] === -1
    ) {
      this.renderGroupedFlags(this.props.flagsSearch, updatedFilterFlags, []);
    } else {
      this.renderGroupedFlags(
        this.props.flagsSearch,
        updatedFilterFlags,
        this.state.userFilterSelectedItems
      );
    }
  };

  handleItemSelect = (flag) => {
    const { selectedItems } = this.state;
    let itemId = flag.flagId;
    if (selectedItems.includes(flag)) {
      // Item is already selected, so deselect it
      this.setState({
        selectedItems: selectedItems.filter((n) => n.flagId !== itemId)
      });
    } else {
      // Item is not selected, so select it
      this.setState({
        selectedItems: [...selectedItems, flag]
      });
    }
  };

  isItemSelected = (flag) => {
    const { selectedItems } = this.state;
    return (
      selectedItems.filter((item) => item.flagId === flag.flagId).length > 0
    );
  };

  handleDocumentPlay = (flagItem) => {
    this.props.dispatch(setPlayerFlag(''));
    this.props.dispatch(setPlayerDocument(this.onDocumentPlay(flagItem)));
    this.props.dispatch(setShowSkipButton(false));
    this.props.dispatch(setPlayResource('flags'));
  };

  onDocumentPlay = async (flagItem) => {
    let playerDocument = '';
    let document = null;

    const documents =
      this.state.documents && this.state.documents.length > 0
        ? this.state.documents
        : this.props.documents;

    document = documents
      ? documents.filter((item) => item.id === flagItem.documentId).shift()
      : null;

    if (document === null || document === undefined) {
      if (firebase.auth.currentUser) {
        const token = await firebase.auth.currentUser.getIdToken();
        if (token) {
          const options = {
            method: 'GET',
            headers: { 'X-Firebase-Auth': token },
            url: `${config.serverURL}/documents?documentId=${flagItem.documentId}`
          };

          try {
            const response = await axios(options);
            document = response.data[0];

            if (document) {
              playerDocument = {
                document: {
                  name: document.documentName,
                  url: document.url
                },
                id: document.id,
                progress: flagItem.trackPosition,
                flagId: flagItem.flagId,
                podcastId: document.podcastId,
                imgUrl: document.imgUrl,
                artistName: document.artistName,
                documentName: document.documentName,
                podcastName: document.podcastName,
                releaseDate: document.releaseDate,
                isOwner: document.isOwner,
                isShareable: flagItem.podcastTypeIds[0] === 5
              };
            }
          } catch (error) {
            console.log(
              `Error on /documents?documentId=${flagItem.flagId}: ${error}`
            );
          }
        }
      }
    } else {
      playerDocument = {
        document: {
          name: document.documentName,
          url: document.url
        },
        id: document.id,
        progress: flagItem.trackPosition,
        flagId: flagItem.flagId,
        podcastId: document.podcastId,
        imgUrl: document.imgUrl,
        artistName: document.artistName,
        documentName: document.documentName,
        podcastName: document.podcastName,
        releaseDate: document.releaseDate,
        isOwner: document.isOwner,
        isShareable: flagItem.podcastTypeIds[0] === 5
      };
    }
    return playerDocument;
  };

  handleTagCommentError = (hasError, errorMessage) => {
    this.setState({ error: { hasError, errorMessage } });
  };

  handleFlagSelectionActionBtn = () => {
    this.setState({
      hiddenSelectionCheckbox: !this.state.hiddenSelectionCheckbox
    });
    if (this.state.hiddenSelectionCheckbox === false) {
      this.props.dispatch(setIsSelectedFlags(false));
      this.setState({ selectedItems: [] });
    }
  };

  handlePlayFlagsActionBtn = (e) => {
    const listOfFlags = this.state.selectedItems;
    if (listOfFlags.length > 0) {
      this.props.dispatch(setIsSelectedFlags(true));
      initializePollyProcess(e, listOfFlags, true, this.handleFlagPlay);
    }
  };

  handleFlagPlay = (listOfFlags) => {
    this.props.dispatch(setPlayerDocument(''));
    this.props.dispatch(setPlayingDocumentId(null));
    this.props.dispatch(setPlayerFlag(listOfFlags[0]));
    this.props.dispatch(setPlaybackFlags(listOfFlags));
    if (listOfFlags.length > 1) {
      this.props.dispatch(setDisableSkipAheadButton(false));
      this.props.dispatch(setDisableSkipBackButton(false));
    } else {
      this.props.dispatch(setDisableSkipAheadButton(true));
      this.props.dispatch(setDisableSkipBackButton(true));
    }
  };

  handleExpandView = () => {
    this.setState({ isExpandedView: !this.state.isExpandedView });
  };

  handleStandarView = () => {
    this.setState({ isExpandedView: false });
  };

  handleShareModalOpen = (flag) => {
    this.setState({ shareModalOpen: true });
    this.setState({ flagsToShare: [flag] });
  };

  handleShareModalInit = async (flag) => {
    const token = await firebase.auth.currentUser.getIdToken();
    if (token) {
      await this.props.dispatch(fetchUserGroups(token, flag?.feedUrl));
      this.handleShareModalOpen(flag);
    }
  };

  handleShareModalClose = () => {
    this.setState({ shareModalOpen: false });
  };

  handleConfirmationDeleteOpen = (flags) => {
    this.setState({ openConfirmationDeleteModal: true, selectedItems: flags });
  };

  closeConfirmationDeleteModal = () => {
    this.setState({ openConfirmationDeleteModal: false });
  };

  handleConfirmationDelete = async () => {
    try {
      const token = await handleDeleteFlags(this.state.selectedItems);

      this.setState({ selectedItems: [] });
      this.closeConfirmationDeleteModal();
      await this.initFetchSearchFlags(token, this.getSearchCriteria());
    } catch (error) {
      // Handle delete error
      console.log(error);
      this.closeConfirmationDeleteModal();
      if (error !== 'SPECIAL_FLAGS') {
        displayNotification(`<p class="contentModal">${error.message}</p>`, {
          title: '<div class="titleModal">Delete Failed</div>',
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: true
        });
      }
    }
  };

  // handle shared users list
  handleSharedFlagsUsers = (data) => {
    const uniqueSharers = [
      {
        userId: -1,
        name: 'All',
        timestamp: ''
      }
    ];
    const uniqueUserIds = new Set();

    data.forEach((item) => {
      if (item.sharedNoteInfo !== null) {
        item.sharedNoteInfo?.sharers.forEach((sharer) => {
          if (!uniqueUserIds.has(sharer.userId)) {
            uniqueUserIds.add(sharer.userId);
            uniqueSharers.push(sharer);
          }
        });
      }
    });
    return uniqueSharers;
  };

  //check what data to return according to button filtering (My or Shared)
  dataAccordingToFilterSelection = (data, filters, selectedUsers) => {
    const checkValueArray = filters.filter((flag) => flag.selected);
    if (checkValueArray.length === 1) {
      if (checkValueArray[0].id === 1) {
        return data?.filter((item) => item.sharedNoteInfo === null);
      } else {
        const sharedFlagData = data?.filter(
          (item) => item.sharedNoteInfo !== null
        );
        if (selectedUsers.length > 0) {
          const fData = this.filterSharedFlagsByUserData(
            sharedFlagData,
            selectedUsers
          );
          return fData;
        } else {
          return sharedFlagData;
        }
      }
    }
    if (selectedUsers.length > 0) {
      const fData = this.filterSharedFlagsByUserData(
        data?.filter((item) => item.sharedNoteInfo !== null),
        selectedUsers
      );
      return fData;
    } else {
      return data;
    }
  };

  // render grouped flags according to filtered(My Flags/ Shared Flags) or original data
  renderGroupedFlags = (data, filters, selectedUsers) => {
    const groupedFlagsObj = {};
    let myGroupedArray = [];
    const filteredData = this.dataAccordingToFilterSelection(data, filters, selectedUsers) || [];
    filteredData.forEach((flag) => {
      if (!groupedFlagsObj[flag.documentId]) {
        groupedFlagsObj[flag.documentId] = [];
      }
      groupedFlagsObj[flag.documentId].push(flag);
    });

    for (const documentId in groupedFlagsObj) {
      myGroupedArray.push(groupedFlagsObj[documentId]);
    }
    myGroupedArray.reverse();
    this.setState({ groupedFlags: myGroupedArray });
  };

  filterSharedFlagsByUserData = (data, userSelectedArray) => {
    if (userSelectedArray.length === 0) {
      return data;
    }
    return data.filter((item) =>
      item.sharedNoteInfo.sharers.some((sharer) =>
        userSelectedArray.includes(sharer.userId)
      )
    );
  };

  handleOnSharedUserFilterChange = (filterItem) => {
    const { userFilterSelectedItems } = this.state;
    const myFilters = [...userFilterSelectedItems];
    let array = [];

    if (myFilters.includes(filterItem.userId)) {
      // Item is already selected, so deselect it
      if (filterItem.userId !== -1) {
        array = myFilters.filter((item) => item !== filterItem.userId);
        this.setState({
          userFilterSelectedItems: array
        });
      } else {
        array = [filterItem.userId];
      }
    } else {
      // Item is not selected, so select it
      if (filterItem.userId === -1) {
        array = [filterItem.userId];
        this.setState({
          userFilterSelectedItems: array
        });
      } else {
        const removeAll = myFilters.filter((item) => item !== -1);
        array = [...removeAll, filterItem.userId];
        this.setState({
          userFilterSelectedItems: array
        });
      }
    }

    const myData = this.props.flagsSearch.filter(
      (item) => item.sharedNoteInfo !== null
    );
    if (array.length === 0 || (array.length === 1 && array[0] === -1)) {
      this.renderGroupedFlags(
        this.props.flagsSearch,
        this.state.filterFlags,
        []
      );
      return;
    }
    const myFilteredData = this.filterSharedFlagsByUserData(myData, array);
    this.renderGroupedFlags(myFilteredData, this.state.filterFlags, array);
  };

  render() {
    return (
      <React.Fragment>
        <div>
          <Navigation />
          <div className="main-page">
            <BlockUi tag="div" blocking={this.state.blocking}>
              <div className="flags-container">
                <Row>
                  {/* Flags Filter */}
                  {!this.state.isExpandedView ? (
                    <FlagsFilters
                      handlerFormCollapse={this.handlerFormCollapse}
                      collapseForm={this.state.collapseForm}
                      filterFlags={this.state.filterFlags}
                      handleFilterFlags={this.handleFilterFlags}
                      handleSelectChangePodcasts={
                        this.handleSelectChangePodcasts
                      }
                      podcastsList={this.podcastsList}
                      valuesPodcasts={this.state.valuesPodcasts}
                      handleSelectChangeDocuments={
                        this.handleSelectChangeDocuments
                      }
                      documentsList={this.documentsList}
                      valuesDocuments={this.state.valuesDocuments}
                      dateFrom={this.state.from}
                      dateTo={this.state.to}
                      handleChangeFrom={this.handleChangeFrom}
                      handleChangeTo={this.handleChangeTo}
                      handleSelectChangeTags={this.handleSelectChangeTags}
                      tagsList={this.tagsList}
                      valuesTags={this.state.valuesTags}
                      handleSelectOnFocus={this.handleSelectOnFocus}
                      onChangeHandler={this.onChangeHandler}
                      handleSubmit={this.handleSubmit}
                      resetForm={this.resetForm}
                      sharedUserList={this.handleSharedFlagsUsers}
                      searchedData={this.props.flagsSearch}
                      handleUserFilterItemSelect={
                        this.handleOnSharedUserFilterChange
                      }
                      userFilterSelectedItems={
                        this.state.userFilterSelectedItems
                      }
                      flashflag={this.state.flashflag}
                      isDocumentsFetching={this.state.isDocumentsFetching}
                    />
                  ) : (
                    <Col xs={12} md={1}>
                      <div
                        onClick={this.handleStandarView}
                        className="flags-filter-minimize__wrapper"
                      >
                        <span className="flags-filter-minimize__btn">
                          <i className="fa fa-search" aria-hidden="true"></i>
                        </span>
                      </div>
                    </Col>
                  )}

                  {/* Flags Main List */}
                  <Col
                    xs={11}
                    md={this.state.isExpandedView ? 10 : 7}
                    className="flags-list__col dash-panel"
                    style={{ color: '#666', fontSize: 14 }}
                  >
                    <Row
                      className="flags-list__sticky-header"
                      style={{
                        color: 'unset',
                        fontSize: 'unset',
                        background:
                          'linear-gradient(45deg, #03123d, transparent)'
                      }}
                    >
                      <Col xs={6}>
                        <h2
                          className="flags-list-title"
                          style={{ color: '#ccc', padding: '16px 0px' }}
                        >
                          Flags
                        </h2>
                      </Col>
                      <Col xs={6}>
                        <div
                          className="flags-list__sticky-header-container"
                          style={{ backgroundColor: 'transparent' }}
                        >
                          <FlagsActions
                            export={this.export}
                            handleFlagSelectionActionBtn={
                              this.handleFlagSelectionActionBtn
                            }
                            isExpandedView={this.state.isExpandedView}
                            handleExpandView={this.handleExpandView}
                            handlePlayFlagsActionBtn={(e) =>
                              this.handlePlayFlagsActionBtn(e)
                            }
                            selectedItems={this.state.selectedItems}
                          />
                          <Row style={{ marginBottom: '12px' }}>
                            <Col xs={12}>
                              <FlagsSelectedActions
                                selectedItems={this.state.selectedItems}
                                hiddenSelectionCheckbox={
                                  this.state.hiddenSelectionCheckbox
                                }
                                handlePlayFlagsActionBtn={(e) =>
                                  this.handlePlayFlagsActionBtn(e)
                                }
                                handleSelectedDelete={
                                  this.handleConfirmationDeleteOpen
                                }
                              />
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                    <div
                      className="flags-list__list-container"
                      id="flags-list-wrapper"
                      style={{ backgroundColor: 'transparent' }}
                    >
                      <Row className>
                        <Col xs={12}>
                          {this.props.loadingFlags && (
                            <>
                              {Array.from({ length: 10 }, (_, index) => (
                                <Box key={index} mb={2}>
                                  <div
                                    className="flags-list-item__box"
                                    style={{
                                      backgroundColor: 'transparent',
                                      color: '#ccc',
                                      boxShadow: '0px 4px 12px #383838'
                                    }}
                                  >
                                    <SearchSkeletonLoader />
                                  </div>
                                </Box>
                              ))}
                            </>
                          )}

                          {!this.props.loadingFlags && (
                            <div>
                              {Array.isArray(this.state.groupedFlags) && this.state.groupedFlags.map(
                                (flagsArr, idx) => (
                                  <Row
                                    style={{ marginBottom: '16px' }}
                                    key={flagsArr[0]?.documentId || idx}
                                  >
                                    <Col xs={12}>
                                      <div className="flags-list-item__box">
                                        <FlagRowHeader
                                          podcast={flagsArr[0]?.podcast}
                                          document={flagsArr[0]?.document}
                                          flags={flagsArr}
                                          handleFlagPlay={this.handleFlagPlay}
                                        />
                                        {flagsArr.map(
                                          (flag) => (
                                            <div key={flag.flagId || flag.id || Math.random()}>
                                            <FlagRow
                                              refresh={this.refresh}
                                              getSearchCriteria={
                                                this.getSearchCriteria
                                              }
                                                key={flag.flagId || flag.id || Math.random()}
                                              flag={flag}
                                              playerDocument={
                                                this.props.playerDocument
                                              }
                                              handleDocumentPlay={
                                                this.handleDocumentPlay
                                              }
                                              selectedItems={
                                                this.state.selectedItems
                                              }
                                              isItemSelected={
                                                this.isItemSelected
                                              }
                                              handleItemSelect={
                                                this.handleItemSelect
                                              }
                                              handleTagCommentError={
                                                this.handleTagCommentError
                                              }
                                              hiddenSelectionCheckbox={
                                                this.state
                                                  .hiddenSelectionCheckbox
                                              }
                                              openShareModal={
                                                this.handleShareModalInit
                                              }
                                              handleDeleteFlag={
                                                this
                                                  .handleConfirmationDeleteOpen
                                              }
                                            />
                                            <hr
                                              style={{
                                                border:
                                                  '1px solid var(--color-medium-dark-gray)'
                                              }}
                                            />
                                          </div>
                                          )
                                        )}
                                      </div>
                                    </Col>
                                  </Row>
                                )
                              )}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </BlockUi>
          </div>
          <div style={{ height: '20px' }}></div>
          <div style={{ height: '20px' }}></div>
          {this.state.shareModalOpen && (
            <ShareFlags
              open={this.state.shareModalOpen}
              onClose={this.handleShareModalClose}
              flagsToShare={this.state.flagsToShare}
            />
          )}
          {this.state.openConfirmationDeleteModal && (
            <ConfirmationDeleteModal
              open={this.state.openConfirmationDeleteModal}
              flags={this.state.selectedItems}
              onCancel={this.closeConfirmationDeleteModal}
              onConfirm={this.handleConfirmationDelete}
            />
          )}
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <ToastContainer />
      </React.Fragment>
    );
  }
}
const mapStateToProps = (store) => {
  return {
    user: store.user,
    documents: store.app.documentsWithFlags,
    flags: store.app.flags,
    podcastsWithFlags: store.app.podcastsWithFlags,
    playerDocument: store.player.playerDocument,
    flagAdded: store.player.flagAdded,
    playingDocumentId: store.app.playingDocumentId,
    loadingFlags: store.flag.loadingFlags,
    flagsSearch: store.flag.flagsSearch,
    tags: store.flag.tags,
    tag: store.flag.tag
  };
};

const authCondition = (authUser) =>
  !!authUser &&
  (isUserStatusSubscribed(authUser.userStatus) ||
    isUserStatusFree(authUser.userStatus)) &&
  (authUser.subscriptionType === undefined ||
    isSubscriptionTypePro(authUser.subscriptionType) ||
    isSubscriptionTypeElite(authUser.subscriptionType));

export default withAuthorization(authCondition)(
  connect(mapStateToProps)(FlagsPage)
);
